import { enumAvailableLanguages } from "./SettingsEnums";

/** Accepts legacy short codes, but exposes only the application's canonical locales. */
export function normalizeUiLanguage(value: string | null | undefined): enumAvailableLanguages {
  const code = value?.trim().toLowerCase().split(/[-_]/)[0];
  return Object.values(enumAvailableLanguages).find(language => language.startsWith(`${code}-`))
    ?? enumAvailableLanguages.german;
}

/** Shared bootstrap fallback used before the main Settings instance exists. */
export function initialUiLanguage(): enumAvailableLanguages {
  return normalizeUiLanguage(localStorage.getItem("itx-language") || navigator.language);
}
